export default "__VITE_ASSET__OInDqCc2__"